import request from "@/utils/request";

export function queryOrder(page, size, data) {
  return request({
    url: "/sys/orderInfo/queryOrders?page=" + page + "&size=" + size,
    method: "post",
    data,
  });
}

async function readOrderPaymentReference(orderId, orderNo) {
  const response = await request({
    url: "/sys/orderInfo/queryOrders",
    method: "post",
    params: { page: 1, size: 20 },
    data: { orderNo },
    silentError: true,
  });
  const orders = response.data && response.data.content;
  let order = null;
  if (Array.isArray(orders)) {
    order = orders.find((item) => {
      return String(item.id) === String(orderId) && item.orderNo === orderNo;
    });
  }
  if (!order) {
    throw new Error("未找到当前订单，请刷新列表后重试");
  }
  return { orderNo: order.orderNo, payId: order.payId };
}

export async function queryOrderPayment(orderId, orderNo) {
  // 同一订单可以产生新流水，先读取后台当前流水，不能直接使用列表中可能过期的 payId。
  const currentOrder = await readOrderPaymentReference(orderId, orderNo);
  if (!currentOrder.payId) {
    throw new Error("该订单暂无支付流水，无法查询支付状态");
  }
  const transforms = [].concat(request.defaults.transformResponse || []);
  transforms.push(function normalizePaymentQueryResponse(response) {
    if (
      response &&
      typeof response === "object" &&
      Object.prototype.hasOwnProperty.call(response, "retCode")
    ) {
      // 此接口返回原始支付响应；仅适配前端的数据外壳，支付结果仍由 retCode、pay_status 判断。
      return { code: "0", data: response };
    }
    // 保留登录失效等标准错误响应，继续交给统一拦截器处理。
    return response;
  });

  const response = await request({
    // 使用现有查单接口，不重新发起支付；上游查单可能触发订单状态同步。
    url: "/sys/test/payCheck",
    method: "get",
    params: { orderId },
    transformResponse: transforms,
    // 由按钮统一提示查询异常，避免网络失败被误认为支付失败或重复弹出提示。
    silentError: true,
  });
  const latestOrder = await readOrderPaymentReference(orderId, orderNo);
  if (latestOrder.payId !== currentOrder.payId) {
    // 查单接口按订单 ID 查当前流水；查询期间换过流水时，无法把结果可靠地对应到某条流水。
    throw new Error("支付流水已变化，本次结果待确认，请重新查询");
  }
  return {
    ...response,
    orderNo: currentOrder.orderNo,
    payId: currentOrder.payId,
  };
}

export function addOrder(data) {
  return request({
    url: "/sys/orderInfo/addOrder",
    method: "post",
    data,
  });
}

export function getOrder(id) {
  return request({
    url: "/sys/orderInfo/getOneOrder/" + id,
    method: "get",
  });
}

export function updateOrder(data) {
  return request({
    url: "/sys/orderInfo/updateOrder",
    method: "post",
    data,
  });
}

export function deleteOrder(data) {
  return request({
    url: "/sys/orderInfo/deleteOrders",
    method: "post",
    data,
  });
}

export function statistic() {
  return request({
    url: "/sys/orderInfo/statistic",
    method: "get",
  });
}
//上传照片
export function uploadPhoto(data) {
  return request({
    url: "/sys/orderInfo/uploadPhoto",
    method: "post",
    data,
  });
}
//重传照片
export function reUploadPhoto(data) {
  return request({
    url: "/sys/orderInfo/reUploadPhoto",
    method: "post",
    data,
  });
}

export function cencelPay(data) {
  return request({
    url: "/sys/orderInfo/cencelPay",
    method: "post",
    data,
  });
}

export function getPhoto(id, headers = {}) {
  return request({
    url: "/file/download/" + id,
    method: "get",
    responseType: "blob",
    timeout: 180000,
    headers,
  });
}

export function queryOrderByEducationId(id) {
  return request({
    url: "/sys/orderInfo/queryOrderByEducationId/" + id,
    method: "get",
  });
}

export function getRegionsByParentId(id) {
  return request({
    url: "/sys/RegionsInfo/getRegionsByParentId/" + id,
    method: "get",
  });
}

export function updateMailinfo(data) {
  return request({
    url: "/sys/orderInfo/updateMailinfo",
    method: "post",
    data,
  });
}
//查询人工识别订单列表接口
export function getFailedOrders(page = 1, size = 20, data) {
  return request({
    url: "/sys/orderInfo/query/FailedOrders?page=" + page + "&size=" + size,
    method: "post",
    data,
  });
}
//查询人工识别订单列表接口
export function getOrderFlowByOrderNo(order = "") {
  return request({
    url: "/sys/orderInfo/getOrderFlowByOrderNo/" + order,
    method: "get",
  });
}
//忽略人脸识别上传
export function getIgnorePhoto(id) {
  return request({
    url: `/sys/orderInfo/ignorePhoto?id=${id}`,
    method: "post",
  });
}
/**
 * 查看订单日志
 * @param {*} id
 * @returns
 */
export function getOrdersLogs(id) {
  return request({
    url: `/sys/orderInfo/getLogs/${id}`,
    method: "get",
  });
}

//查询扣款失败订单列表
export function getFailedPay(page = 1, size = 20, data) {
  return request({
    url: "/sys/orderInfo/query/FailedPay?page=" + page + "&size=" + size,
    method: "post",
    data,
  });
}

//扣款失败订单---取消订单接口
export function cencelPaySupplement(data) {
  return request({
    url: `/sys/orderInfo/cencelPay/Supplement`,
    method: "post",
    data,
  });
}
/**
 * 查询E钱包开通数据
 * @param {*} data
 */
export function epayStatistics(data) {
  return request({
    url: `/sys/orderInfo/epayStatistics`,
    method: "post",
    data,
  });
}

//批量替换照片---列表(校拍)
export function getReplacePhotos(currentPage = 1, pageSize = 20, data) {
  return request({
    url:
      "/sys/taskInfo/replacePhotos?currentPage=" +
      currentPage +
      "&pageSize=" +
      pageSize,
    method: "post",
    data,
  });
}

// //批量替换照片---查看处理进度(校拍)
// export function getqueryTasks(currentPage = 1, pageSize = 20, data) {
//   return request({
//     url: "/sys/replacePhotoTask/query/tasks?currentPage=" + currentPage + "&pageSize=" + pageSize,
//     method: "post",
//     data,
//   });
// }
//校拍批量下载
export function getDownloadReplace(taskId) {
  return request({
    url: "/sys/taskInfo/downloadReplace?taskId=" + taskId,
    method: "get",
    taskId,
  });
}

//批量替换照片---列表(散拍)
export function getReplacePhotosSP(currentPage = 1, pageSize = 20, data) {
  return request({
    url:
      "/sys/orderInfo/query/ReplacePhotos?currentPage=" +
      currentPage +
      "&pageSize=" +
      pageSize,
    method: "post",
    data,
  });
}
//批量替换散拍---创建替换任务
export function replacePhotoTaskAdd(data = {}) {
  return request({
    url: `/sys/replacePhotoTask/add`,
    method: "post",
    data,
  });
}

//批量替换照片---列表(散拍)、、//批量替换照片---查看处理进度(校拍)

export function getQueryTasks(currentPage = 1, pageSize = 20, data) {
  return request({
    url:
      "/sys/replacePhotoTask/query/tasks?currentPage=" +
      currentPage +
      "&pageSize=" +
      pageSize,
    method: "post",
    data,
  });
}

//散拍批量下载
export function getDownloadReplaceSp(id) {
  return request({
    url: "/sys/orderInfo/downloadReplace?id=" + id,
    method: "get",
    id,
  });
}

//批量替换照片---查看明细(散拍)
export function getQueryinfos(currentPage = 1, pageSize = 20, data) {
  return request({
    url:
      "/sys/replacePhotoTask/query/infos?currentPage=" +
      currentPage +
      "&pageSize=" +
      pageSize,
    method: "post",
    data,
  });
}

//批量替换照片---查看失败学生(散拍)
export function getQueryreplaceFail(currentPage = 1, pageSize = 20, data) {
  return request({
    url:
      "/sys/replacePhotoTask/query/replaceFail?currentPage=" +
      currentPage +
      "&pageSize=" +
      pageSize,
    method: "post",
    data,
  });
}

//散拍批量下载
export function getFailReplace(id) {
  return request({
    url: "/sys/replacePhotoTask/download/FailReplace?id=" + id,
    method: "get",
    id,
  });
}

//批量替换---上传替换照片
export function uploadFile(data) {
  return request({
    url: `/sys/replacePhotoTask/uploadFile`,
    method: "post",
    data,
  });
}

//批量替换---获取上传复核列表
export function photoDetail(id) {
  return request({
    url: "/sys/replacePhotoTask/photoDetail?id=" + id,
    method: "get",
    id,
  });
}

// 获取普通照片的短期 OSS 签名预览地址。
export function getPhotoPreviewUrl(fileId) {
  return request({
    url: "/file/preview-url/" + fileId,
    method: "get",
    silentError: true,
  });
}

//批量替换---是否确认替换
export function checkReplace(data) {
  return request({
    url: "/sys/replacePhotoTask/checkReplace",
    method: "post",
    data,
  });
}

//批量替换照片---查看处理进度(散拍)
export function getCheckProgress(id) {
  return request({
    url: "/sys/replacePhotoTask/checkProgress?id=" + id,
    method: "get",
    id,
  });
}
// 已处理完成pots请求
export function setPhtotHandle(taskId) {
  return request({
    url: `/sys/replacePhotoTask/isHandle/${taskId}`,
    method: "post",
  });
}

//散拍物流接口
export function getLogistics(traceNo) {
  return request({
    url: "/sys/ems/mail/logistics?traceNo=" + traceNo,
    method: "get",
    traceNo,
  });
}

//分片上传
export function minioUpload(data) {
  return request({
    url: "/sys/minio/upload",
    headers: {
      "Content-Type": "application/json",
    },
    processData: false,
    contentType: false,
    method: "post",
    data,
  });
}

// 合并分片
export function merge(data) {
  return request({
    url: "/sys/minio/merge",
    headers: {
      "Content-Type": "application/json",
    },
    method: "post",
    data,
  });
}

// 合并结尾
export function mergeEnd(data) {
  return request({
    url: "/sys/replacePhotoTask/uploadFile",
    headers: {
      "Content-Type": "application/json",
    },
    method: "post",
    data,
  });
}

// 合并结尾
export function uploadFileBase64un(params = {}, headers = {}) {
  return new Promise((resolve, reject) => {
    http
      .post(api.files_base64_un, params, headers)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

//创建散拍任务
export function casualPhotoTaskAdd(data = {}) {
  return request({
    url: "/sys/casualPhotoTask/add",
    method: "post",
    data,
  });
}

//选择订单——散拍
export function queryOrders(data = {}, currentPage, pageSize) {
  return request({
    url:
      "/sys/orderInfo/query/orders?currentPage=" +
      currentPage +
      "&pageSize=" +
      pageSize,
    method: "post",
    data,
  });
}

/**
 * 强制取消订单（已完成的订单）
 * @param {*}
 * @returns
 */
export function forceCancelPay(data) {
  return request({
    url: "/sys/orderInfo/forceCancelPay",
    method: "post",
    data,
  });
}

/**
 * 散拍列表上传采集码
 * @param {*}
 * @returns
 */
export function uploadCjm(data) {
  return request({
    url: "/sys/orderInfo/uploadCjm",
    headers: {
      "Content-Type": "application/json",
    },
    method: "post",
    data,
  });
}

//创建散拍任务--时间回退一周提示
export function ordersCount(data) {
  return request({
    url: "/sys/orderInfo/query/ordersCount",
    method: "post",
    data,
  });
}
//查询采集支付订单
export function getOrderByCjm(data) {
  return request({
    url: "/sys/orderInfo/getOrderByCjm",
    method: "post",
    data,
  });
}
//重新同步订单
export function reSyncOrder(data) {
  return request({
    url: "/sys/orderInfo/reSync?id=" + data.id,
    method: "post",
    data,
  });
}
//同步订单
export function reSyncOrderFirst(data) {
  return request({
    url: "/sys/orderInfo/reSyncOrder?id=" + data.id,
    method: "post",
    data,
  });
}
